import { CoreIcon } from '../core-icon';
import faceIdSVG from '../../assets/icons/face-id.svg';
import type { IconProps } from '../core-icon';

export const FaceIdIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={faceIdSVG} {...props} />;
};
